import React from "react";
import "./XeroxFooter.css";

const XeroxFooter = function(props) {
  return (
    <footer className={ props.class!=undefined? ("RobotoFont footer mt-auto py-3 bg-lighter xerox-footer "+ props.class):"RobotoFont footer mt-auto py-3 bg-lighter xerox-footer"}>
      <div className="container">
        <p className="my-0 text-center" style={{color: "#808285", fontSize: 0.92+"rem"}}>
        {props.Reader_AllRightsReserved +" | "}
        <a href="https://rpost.com/legal-notices/privacy-notice-rdocs-supplement" target="_blank" style={{color: "#808285"}} >{props.Reader_Terms}</a>
        </p>
      </div>
    </footer>
  );
};
export default XeroxFooter;